module.exports = __webpack_public_path__ + "files/afe7c6d256c0413730862a09214dc850.png";